<template>
  <AppTooltip v-bind="$attrs">
    <template #activator="{ props }">
      <v-icon v-bind="props"
              class="mx-1"
              size="14"
      >
        fas fa-question-circle
      </v-icon>
    </template>
    <span v-html="text"></span>
  </AppTooltip>
</template>

<script>
import AppTooltip from './AppTooltip.vue'
/**
 * @displayName AppHelpTooltip
 */
/**
 * Default Help tooltip.
 * Uses the AppTooltip component.
 */
export default {
  name: 'AppHelpTooltip',
  components: {
    AppTooltip,
  },
  inheritAttrs: false,
  props: {
    /**
     * Text displayed in tooltip
     */
    text: {
      type: String,
      required: true,
    },
  },
}
</script>

<style scoped lang="scss">
  .v-icon {
    color: rgba(0, 0, 0, .54);
  }
</style>

<!--<docs>-->
<!--```vue-->
<!--<template>-->
<!--  <div>-->
<!--    Some text-->
<!--    <AppHelpTooltip text="My tooltip"/>-->
<!--  </div>-->
<!--</template>-->
<!--```-->
<!--</docs>-->
